"use client";

import WarnaLogoCard from "@/app/Components/WarnaLogoCard";
import { WarnaLogos } from "../constant";

const WarnaLogo = () => {
  return (
    <div className="relative flex flex-col px-5 md:px-10 lg:px-20 pb-10 lg:pb-20 overflow-hidden gap-10">
      <h3 className="text-cust-blue text-4xl md:text-5xl font-bold text-center lg:text-left">
        Pilihan Warna dalam Logo: <br className="hidden md:block"/> Sebuah Representasi
      </h3>
      <div className="space-y-10">
        {WarnaLogos.map((warna, index) => (
          <WarnaLogoCard
            key={index}
            title={warna.title}
            description={warna.description}
            hexCodes={warna.hexCodes}
            image={warna.image}
            direction={index % 2 === 0 ? "left" : "right"}
          />
        ))}
      </div>
    </div>
  );
};

export default WarnaLogo;
